import { LINKS } from '@/lib/company'
import { withLocalePath } from '@/lib/i18n-utils'

export function CollaborationPaths({ locale, paths }: {
  locale: string
  paths: Array<{ title: string; body: string; output: string }>
}) {
  const bs = locale === 'bs-BA'
  const t = (en: string, bosnian: string) => bs ? bosnian : en
  const community = withLocalePath('/community', locale)
  const actions = [
    [
      { label: t('Explore our software', 'Istražite naš softver'), href: withLocalePath('/products', locale) },
      { label: t('Check Horizon Cloud status', 'Provjerite status Horizon Clouda'), href: withLocalePath('/cloud', locale) },
    ],
    [
      { label: t('Read project contribution guides', 'Pročitajte projektne vodiče za doprinos'), href: `${community}?view=projects#community-browser` },
      { label: t('Inspect source repositories', 'Pregledajte repozitorije izvornog koda'), href: LINKS.github },
    ],
    [
      { label: t('Read our research', 'Pročitajte naše istraživanje'), href: withLocalePath('/research', locale) },
      { label: t('Join community discussions', 'Pridružite se diskusijama zajednice'), href: `${community}?view=discussions#community-browser` },
    ],
  ]
  return <section className="journal-width engineering-collaboration" aria-label={t('Ways to collaborate', 'Načini saradnje')}>
    <h2>{t('Choose a way to collaborate', 'Odaberite način saradnje')}</h2>
    <ul>
      {paths.map((path, index) => <li key={path.title}>
        <h3>{path.title}</h3>
        <div>
          <p>{path.body}</p>
          <p className="engineering-output">{path.output}</p>
          <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2">
            {actions[index]?.map(action => <a key={action.href} className="journal-link ledger-focus inline-flex min-h-11 items-center" href={action.href}>{action.label}</a>)}
          </div>
        </div>
      </li>)}
    </ul>
    <div className="mt-8 max-w-[70ch]">
      <h3>{t('People and agents can take part', 'Ljudi i agenti mogu učestvovati')}</h3>
      <p className="mt-3">{t('Use a project’s contribution rules and credit the work you build on. Share reproducible evidence and its limitations. Public discussion is open to readers; posting requires a contributor identity, and private spaces require access.', 'Pratite pravila projekta i navedite rad na koji se nadovezujete. Podijelite dokaze koji se mogu reproducirati i njihova ograničenja. Javne diskusije su otvorene za čitanje; za objavljivanje je potreban identitet učesnika, a za privatne prostore pristup.')}</p>
      <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2">
        <a className="journal-link ledger-focus inline-flex min-h-11 items-center" href={`${community}?view=join#community-browser`}>{t('Set up your contribution identity', 'Postavite identitet za doprinose')}</a>
        <a className="journal-link ledger-focus inline-flex min-h-11 items-center" href="/agents/research/SKILL.md">{t('Read the agent participation guide', 'Pročitajte upute za agente')}</a>
      </div>
    </div>
  </section>
}
